import { Dispatch, SetStateAction } from 'react';
import { PartyModel } from '../../../types';
import { routes } from '../../../routes/routes';

interface RemoveInvitationResponse {
  statusCode: number;
}

interface RemoveInvitationAndNavigateOptions {
  groupId: string;
  invitedFriendId: string;
  removeInvitation: (groupId: string, invitedFriendId: string) => Promise<RemoveInvitationResponse>;
  setMyPartiesInfoContextData: (updater: (previousParties: PartyModel[]) => PartyModel[]) => void;
  setSelectedPartyContextData: Dispatch<SetStateAction<PartyModel | null>>;
  closeConfirmationModal: () => void;
  navigate: (route: string, options?: { replace?: boolean }) => void;
}

export const removeInvitationAndNavigate = async ({
  groupId,
  invitedFriendId,
  removeInvitation,
  setMyPartiesInfoContextData,
  setSelectedPartyContextData,
  closeConfirmationModal,
  navigate,
}: RemoveInvitationAndNavigateOptions) => {
  const result = await removeInvitation(groupId, invitedFriendId);

  if (result.statusCode !== 200) {
    throw new Error('Failed to remove the invitation.');
  }

  setMyPartiesInfoContextData((prev) =>
    prev.map((party) =>
      party.party.id === groupId
        ? {
            ...party,
            invitations: party.invitations.filter((invitation) => invitation.id !== invitedFriendId),
          }
        : party
    )
  );

  setSelectedPartyContextData((prev) => {
    if (!prev || prev.party.id !== groupId) return prev;
    return {
      ...prev,
      invitations: prev.invitations.filter((invitation) => invitation.id !== invitedFriendId),
    };
  });

  closeConfirmationModal();
  navigate(routes.MyPartyWithId(groupId), { replace: true });
};
